import { useEffect, useState } from "react"
import { Routes as Switch, useLocation } from "react-router-dom"
import TopBarProgress from "react-topbar-progress-indicator"
// import LoadingScreenWithLogo from '../../pages/Splash-Screens/LoadingScreenWithLogo';

interface RouteSwitchType {
   children: any
}
export default function RouteSwitch(props: RouteSwitchType) {
   const children = props.children;
   const [progress, setProgress] = useState(false)
   const [prevLoc, setPrevLoc] = useState("")
   const location = useLocation()

   TopBarProgress.config({
      barColors: {
         "0": "rgb(2, 5, 129)",
         "0.5": "rgb(2, 15, 129)",
         "1.0": "rgb(2, 30, 129)",
      },
      shadowBlur: 5
   })

   useEffect(() => {
      setPrevLoc(location.pathname)
      setProgress(true)
      if (location.pathname === prevLoc) {
         setPrevLoc('')
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [location])

   useEffect(() => {
      setProgress(false)
      window.scrollTo({ top: 0, behavior: 'smooth' })
   }, [prevLoc])

   return (
      <>
         {progress && <TopBarProgress />}
         <Switch>{children}</Switch>
      </>
   )
}
// export default function RouteSwitch(props: RouteSwitchType) {
//    const children = props.children;
//    const [progress, setProgress] = useState(false)
//    const [showSplashScreen, HideSplashScreen] = useState(true);
//    const [prevLoc, setPrevLoc] = useState("")
//    const location = useLocation()
//    TopBarProgress.config({
//       barColors: {
//          "0": "#9427F7",
//          "0.5": "#FF4477",
//          "1.0": "#FFBB33",
//       },
//       shadowBlur: 5
//    })
//    useEffect(() => {
//       setPrevLoc(location.pathname)
//       setProgress(true)
//       if (location.pathname === prevLoc) {
//          setPrevLoc('')
//       }
//    }, [location])

//    useEffect(() => {
//       setProgress(false)
//       window.scrollTo({ top: 0, behavior: 'smooth' })
//    }, [prevLoc])

//    // useEffect(() => {
//    //    setTimeout(() => {
//    //       SetShowSplashScreen(false);
//    //    }, 9500);
//    // });

//    return (
//       !showSplashScreen ?
//          (
//             <>
//                {progress && <TopBarProgress />}
//                <Switch>{children}</Switch>
//             </>
//          )
//          :
//          (
//             <LoadingScreenWithLogo hideSplashScreen={HideSplashScreen} />
//          )
//    )
// }